import gql from 'graphql-tag';
import { SOCIAL_INTERACTION_TARGET_FRAGMENT } from '.';
export const CREATE_REACTION = gql `
  mutation SocialCreateReaction(
    $urn: GlobalID!
    $trackingMetadata: SocialTrackingMetadataInput
  ) {
    socialCreateReaction(
      input: {
        interactionTargetUrn: $urn
        reactionType: LIKE
        trackingMetadata: $trackingMetadata
      }
    ) {
      success {
        interactionTarget {
          ...SocialInteractionTarget
        }
      }
    }
  }
  ${SOCIAL_INTERACTION_TARGET_FRAGMENT}
`;
//# sourceMappingURL=create-reaction.gql.js.map